// extracted by mini-css-extract-plugin
module.exports = {"tip":"style_tip__uX8ap"};